/* GrowJoy Kids — Garden Rescue (game, ages 5–10, guide: Bella)
   Mounts into: <div data-kids-app="garden-rescue" data-mascot="…buzzy.jpg" data-badges='{"bug-explorer":"…png",…}'></div>
   Needs: kids-shared.css, kids-badges.js. No other dependencies, no network calls.
   Learning: garden friends vs pests, watering balance (too little / too much), weeds compete for water. */
(function () {
  "use strict";

  /* ---------- content (horticultural review pending — see CONTENT-REVIEW.md) ---------- */
  var GUIDE = {
    aphid:       { name: "Aphid",       side: "foe",    fact: "Tiny bugs that suck the sap out of leaves and stems." },
    ladybug:     { name: "Ladybug",     side: "friend", fact: "A hungry helper. One ladybug can eat dozens of aphids a day." },
    caterpillar: { name: "Caterpillar", side: "foe",    fact: "Munches holes in leaves. It grows up into a moth or butterfly." },
    weed:        { name: "Weed",        side: "foe",    fact: "Steals water and food from your plant. Pull it out while it is small." },
    worm:        { name: "Earthworm",   side: "friend", fact: "Digs tunnels so air and water reach the roots. Its droppings feed plants." },
    snail:       { name: "Snail",       side: "foe",    fact: "Chews big holes in leaves, mostly at night." },
    bee:         { name: "Bee",         side: "friend", fact: "Carries pollen between flowers so fruits and seeds can grow." }
  };
  var ORDER = ["aphid", "ladybug", "caterpillar", "weed", "worm", "snail", "bee"];
  var LEVELS = [
    { name: "Seedling",  time: 30, spawn: { aphid: 2.3, ladybug: 8 } },
    { name: "Growing",   time: 35, spawn: { aphid: 2.0, ladybug: 9, caterpillar: 5, weed: 6, worm: 9 } },
    { name: "Flowering", time: 40, spawn: { aphid: 1.6, ladybug: 8, caterpillar: 4.5, weed: 5.5, worm: 9, snail: 6.5, bee: 5 } }
  ];
  var BETWEEN = [
    { title: "Your seedling is growing!", fact: "Did you see a ladybug eat an aphid? Let garden friends do some of the work for you." },
    { title: "Almost a flower!", fact: "Weeds fight your plant for water and food. Gardeners pull them out while they are small." }
  ];
  var WATER_LOW = 25, WATER_HIGH = 95;

  function mount(root) {
    var mascot = root.getAttribute("data-mascot") || "";
    var mascotReaction = root.getAttribute("data-mascot-reaction") || mascot;
    var badges = {}; try { badges = JSON.parse(root.getAttribute("data-badges") || "{}"); } catch (e) {}
    var reduced = window.GrowJoyUI.reduced();

    root.classList.add("gj");
    root.innerHTML =
      '<div class="gj-game">' +
        '<div class="gj-main">' +
          '<div class="gj-titlebar"><div><h1>Garden Rescue</h1><p class="gj-sub">Protect your plant from seed to flower.</p></div><span class="gj-chip">Ages 5–10 · 3 levels</span></div>' +
          '<div class="gj-hud">' +
            '<div class="gj-meter"><span>Plant health <em data-r="hp">100</em></span><div class="gj-bar"><div class="gj-fill" data-r="hpf" style="width:100%;background:var(--gj-green)"></div></div></div>' +
            '<div class="gj-meter"><span>Water <em data-r="wt">Just right</em></span><div class="gj-bar"><div class="gj-fill" data-r="wtf" style="width:60%;background:var(--gj-blue)"></div><div class="gj-zone" style="left:25%;width:70%"></div></div></div>' +
            '<div class="gj-meter" style="align-items:flex-end"><span class="gj-num" data-r="score">0</span><span data-r="lvl" style="color:var(--gj-muted)">Level 1 · 30s</span></div>' +
          '</div>' +
          '<div class="gj-stage gr-stage"><canvas data-r="cv" tabindex="0" role="application" aria-label="Garden. Use left and right arrows to move the rain cloud. Press space to flick away the pest closest to your plant."></canvas>' +
            '<button class="gr-pause" data-r="pause" type="button" aria-label="Pause" hidden>II</button>' +
            '<div class="gj-overlay" data-r="ov"></div></div>' +
          '<div class="gj-guide" data-r="guide" aria-live="polite"><img src="' + mascot + '" alt="Bella the bee"><p data-r="tip"></p></div>' +
        '</div>' +
        '<aside class="gj-side">' +
          '<div class="gj-card"><h3>How to play</h3><ul class="gj-howto">' +
            '<li><b class="k">Tap</b>Tap pests to flick them off your plant.</li>' +
            '<li><b class="k">Drag</b>Drag the rain cloud over your plant to water it. Not too much!</li>' +
            '<li><b class="k">Tap</b>Pull out weeds. They steal your plant\'s water.</li>' +
            '<li><b class="k">Stop</b>Never tap garden friends. They help you!</li></ul>' +
            '<p class="gj-keys">Keyboard: ← → move the cloud · Space flicks the pest nearest your plant · P pauses</p></div>' +
          '<div class="gj-card"><h3>Garden Guide</h3><div class="gr-guidebook" data-r="book"></div></div>' +
          '<div class="gj-card"><h3>Your badges</h3><div class="gj-shelf" data-r="shelf" style="margin-top:8px"></div></div>' +
        '</aside>' +
      '</div>';

    var $ = function (k) { return root.querySelector('[data-r="' + k + '"]'); };
    var cv = $("cv"), ctx = cv.getContext("2d");
    var W = 400, H = 480, g = null, raf = 0, last = 0, drag = null, keys = {};
    var best = 0; try { best = Number(localStorage.getItem("gr-best")) || 0; } catch (e) {}

    function shelf() { window.GrowJoyUI.shelf($("shelf"), function (id) { return badges[id] || ""; }); }
    function book() {
      $("book").innerHTML = ORDER.map(function (k) {
        var d = GUIDE[k], f = g && g.found[k];
        return '<div class="' + (f ? d.side : "locked") + '"><b>' + (f ? d.name : "???") + "</b>" + (f ? (d.side === "friend" ? "Friend" : "Pest") : "Not found yet") + "</div>";
      }).join("");
    }
    function tip(html, mood) {
      $("tip").innerHTML = html;
      $("guide").className = "gj-guide" + (mood ? " " + mood : "");
      $("guide").querySelector("img").src = mood === "good" ? mascotReaction : mascot;
    }

    function size() {
      var w = cv.parentElement.clientWidth || 400, dpr = Math.min(2, window.devicePixelRatio || 1);
      W = w; H = Math.round(Math.min(w * 1.15, 560));
      cv.width = W * dpr; cv.height = H * dpr; cv.style.height = H + "px";
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      if (g) { g.px = W / 2; g.gy = H * 0.8; }
      draw();
    }

    function fresh() {
      return { level: 0, t: 0, score: 0, health: 100, water: 60, ents: [], pops: [], timers: {}, mistakes: 0, found: {},
               cloud: { x: W * 0.25, vx: 14, raining: false }, px: W / 2, gy: H * 0.8, mode: "intro", tipLock: 0, ate: 0 };
    }

    /* ---------- flow ---------- */
    function startLevel() {
      g.mode = "play"; g.t = 0; g.ents = []; g.timers = {};
      var sp = LEVELS[g.level].spawn;
      for (var k in sp) g.timers[k] = 1 + Math.random() * sp[k];
      $("ov").hidden = true; $("pause").hidden = false;
      tip("<b>Level " + (g.level + 1) + ": " + LEVELS[g.level].name + ".</b> Keep your plant safe!", null);
      cv.focus({ preventScroll: true });
      last = performance.now(); cancelAnimationFrame(raf); raf = requestAnimationFrame(loop);
    }
    function endLevel() {
      g.mode = "card"; cancelAnimationFrame(raf); draw(); $("pause").hidden = true;
      if (g.level === LEVELS.length - 1) return win();
      var b = BETWEEN[g.level];
      overlay('<img class="gj-mascot" src="' + mascot + '" alt=""><h2>' + b.title + "</h2><p>" + b.fact + "</p>", "Next level", function () { g.level++; startLevel(); });
    }
    function win() {
      g.mode = "won"; draw();
      var stars = g.health >= 70 && g.mistakes <= 1 ? 3 : g.health >= 40 ? 2 : 1;
      var rec = ""; try { if (g.score > best) { best = g.score; localStorage.setItem("gr-best", String(best)); rec = " New best score!"; } } catch (e) {}
      window.GrowJoyUI.celebrate({
        stage: cv.parentElement, overlay: $("ov"), badgeId: "bug-explorer", badgeSrc: badges["bug-explorer"] || "",
        title: "Your plant flowered!", stars: stars,
        text: "Score " + g.score + "." + rec + " " + (g.mistakes ? "You tapped " + g.mistakes + " garden friend" + (g.mistakes > 1 ? "s" : "") + " by mistake. Next time, let them help!" : "You never hurt a garden friend. Great gardening!"),
        again: begin
      });
      tip("<b>Bzzz, you did it!</b> You know who helps the garden and who harms it.", "good");
      shelf();
    }
    function lose() {
      g.mode = "lost"; cancelAnimationFrame(raf); draw(); $("pause").hidden = true;
      var why = g.water < WATER_LOW ? "Your plant got too thirsty. Drag the cloud over it to water it." :
                g.water > WATER_HIGH ? "Too much water drowned the roots. Move the cloud away when the water bar is full." :
                "The pests ate too many leaves. Tap them quickly, and let the ladybugs help.";
      overlay('<img class="gj-mascot" src="' + mascot + '" alt=""><h2>Oh no, your plant wilted</h2><p>' + why + "</p>", "Try again", begin);
      tip("<b>Don't give up!</b> Every gardener loses a plant sometimes.", "oops");
    }
    function begin() { $("cv").parentElement.classList.remove("gr-stage--intro"); g = fresh(); g.mode = "play"; book(); startLevel(); }
    function pause() {
      if (!g || g.mode !== "play") return;
      g.mode = "paused"; cancelAnimationFrame(raf); $("pause").hidden = true;
      overlay("<h2>Paused</h2><p>Your garden is waiting.</p>", "Keep playing", function () { g.mode = "play"; $("ov").hidden = true; $("pause").hidden = false; cv.focus({ preventScroll: true }); last = performance.now(); raf = requestAnimationFrame(loop); });
    }
    function overlay(html, label, fn) {
      var o = $("ov");
      o.innerHTML = html + '<div class="gj-actions"><button class="gj-btn" type="button">' + label + "</button></div>";
      o.hidden = false;
      var b = o.querySelector("button"); b.addEventListener("click", fn); b.focus({ preventScroll: true });
    }

    /* ---------- spawning ---------- */
    function plantH() {
      var base = [0.16, 0.3, 0.44][g.level], next = [0.3, 0.44, 0.52][g.level];
      var p = g.mode === "play" || g.mode === "paused" ? Math.min(1, g.t / LEVELS[g.level].time) : 1;
      return H * (base + (next - base) * p);
    }
    function spawn(type) {
      var side = Math.random() < 0.5 ? -1 : 1, ph = plantH();
      var e = { type: type, t: 0, life: 99, dead: false, hp: 1, label: 0 };
      if (type === "aphid") { e.x = side < 0 ? -10 : W + 10; e.y = H * 0.25 + Math.random() * H * 0.3; e.tx = g.px + (Math.random() - 0.5) * 40; e.ty = g.gy - ph * (0.35 + Math.random() * 0.6); e.sp = 55; e.r = 13; }
      if (type === "caterpillar") { e.x = side < 0 ? -30 : W + 30; e.y = g.gy - 8; e.tx = g.px; e.ty = g.gy - 8; e.sp = 26; e.r = 22; }
      if (type === "snail") { e.x = side < 0 ? -30 : W + 30; e.y = g.gy - 12; e.tx = g.px; e.ty = g.gy - 12; e.sp = 16; e.r = 22; e.hp = 2; }
      if (type === "weed") { e.x = g.px + side * (60 + Math.random() * (W * 0.32)); e.y = g.gy + 4; e.grow = 0; e.r = 24; }
      if (type === "ladybug") { e.x = side < 0 ? -10 : W + 10; e.y = H * 0.3 + Math.random() * H * 0.3; e.sp = 70; e.r = 16; e.life = 11; }
      if (type === "bee") { e.x = side < 0 ? -20 : W + 20; e.y = H * 0.2 + Math.random() * H * 0.15; e.vx = side < 0 ? 90 : -90; e.r = 18; e.life = 14; e.visit = 0; }
      if (type === "worm") { e.x = g.px + side * (50 + Math.random() * (W * 0.3)); e.y = g.gy + 12; e.r = 22; e.life = 5; }
      if (!g.found[type]) {
        g.found[type] = true; e.label = 3.5; book();
        var d = GUIDE[type];
        tip('<span class="gj-tag ' + d.side + '">' + (d.side === "friend" ? "Friend" : "Pest") + "</span><b>New: " + d.name + "!</b> " + d.fact + " " + (d.side === "friend" ? "Don't tap it." : "Tap it away!"), null);
        g.tipLock = 4;
      }
      g.ents.push(e);
    }

    /* ---------- update ---------- */
    function loop(now) {
      var dt = Math.min(0.05, (now - last) / 1000); last = now;
      update(dt); draw();
      if (g.mode === "play") raf = requestAnimationFrame(loop);
    }
    function update(dt) {
      var L = LEVELS[g.level], k, e;
      g.t += dt; g.tipLock -= dt;
      for (k in L.spawn) { g.timers[k] -= dt; if (g.timers[k] <= 0) { g.timers[k] = L.spawn[k] * (0.7 + Math.random() * 0.6); spawn(k); } }
      var cl = g.cloud;
      if (keys.ArrowLeft) cl.x -= 220 * dt;
      if (keys.ArrowRight) cl.x += 220 * dt;
      if (!drag && !keys.ArrowLeft && !keys.ArrowRight) {
        cl.x += cl.vx * dt;
        if (cl.x < 60 || cl.x > W - 60) cl.vx *= -1;
        if (Math.random() < dt * 0.15) cl.vx *= -1;
      }
      cl.x = Math.max(60, Math.min(W - 60, cl.x));
      cl.raining = Math.abs(cl.x - g.px) < 45;
      var weeds = g.ents.filter(function (x) { return x.type === "weed" && !x.dead; }).length;
      g.water += (cl.raining ? 16 : 0) * dt - (2.4 + weeds * 1.6) * dt;
      g.water = Math.max(0, Math.min(100, g.water));
      if (g.water < WATER_LOW) { g.health -= 4 * dt; if (g.tipLock <= 0) { tip("<b>Thirsty!</b> Drag the rain cloud over your plant.", "oops"); g.tipLock = 3; } }
      if (g.water > WATER_HIGH) { g.health -= 3 * dt; if (g.tipLock <= 0) { tip("<b>Too much water!</b> Roots need air too. Move the cloud away.", "oops"); g.tipLock = 3; } }
      for (var i = 0; i < g.ents.length; i++) {
        e = g.ents[i];
        if (e.dead) { e.fly += dt; continue; }
        e.t += dt; e.life -= dt; if (e.label > 0) e.label -= dt;
        if (e.type === "aphid" || e.type === "caterpillar" || e.type === "snail") {
          var dx = e.tx - e.x, dy = e.ty - e.y, d = Math.hypot(dx, dy);
          if (d > 4) { e.x += dx / d * e.sp * dt; e.y += dy / d * e.sp * dt; e.eating = false; }
          else {
            e.eating = true; g.health -= (e.type === "aphid" ? 2.5 : 4.5) * dt;
            if (g.tipLock <= 0) { tip("<b>The " + GUIDE[e.type].name.toLowerCase() + " is eating your plant!</b> Tap it away.", "oops"); g.tipLock = 3; }
          }
        }
        if (e.type === "weed") e.grow = Math.min(1, e.grow + dt * 0.25);
        if (e.type === "ladybug") {
          var prey = null, pd = 1e9;
          g.ents.forEach(function (a) { if (a.type === "aphid" && !a.dead) { var q = Math.hypot(a.x - e.x, a.y - e.y); if (q < pd) { pd = q; prey = a; } } });
          var tx = prey ? prey.x : (e.x < W / 2 ? -40 : W + 40), ty = prey ? prey.y : e.y;
          if (e.life <= 0) tx = e.x < W / 2 ? -60 : W + 60;
          var ddx = tx - e.x, ddy = ty - e.y, dd = Math.hypot(ddx, ddy) || 1;
          e.x += ddx / dd * e.sp * dt; e.y += ddy / dd * e.sp * dt; e.ang = Math.atan2(ddy, ddx);
          if (prey && dd < 14) {
            prey.dead = true; prey.fly = 0; g.score += 5; g.ate++;
            pop("Ladybug ate an aphid! +5", prey.x, prey.y, "#1e8fe1");
            if (g.ate === 1) { tip('<span class="gj-tag friend">Friend</span><b>Yum!</b> The ladybug ate an aphid. Garden friends help you, so never tap them.', "good"); g.tipLock = 4; }
          }
          if (e.x < -50 || e.x > W + 50) e.gone = true;
        }
        if (e.type === "bee") {
          e.x += e.vx * dt; e.y += Math.sin(e.t * 5) * 20 * dt;
          if (g.level === 2 && !e.visit && Math.abs(e.x - g.px) < 20) { e.visit = 1; g.score += 15; pop("Bee pollinated! +15", g.px, g.gy - plantH() - 20, "#1e8fe1"); }
          if (e.x < -40 || e.x > W + 40) e.gone = true;
        }
        if (e.type === "worm" && e.life <= 0) e.gone = true;
      }
      g.ents = g.ents.filter(function (x) { return !x.gone && !(x.dead && x.fly > 0.6); });
      g.pops.forEach(function (p) { p.t += dt; });
      g.pops = g.pops.filter(function (p) { return p.t < 1.2; });
      g.health = Math.max(0, Math.min(100, g.health));
      if (g.health <= 0) return lose();
      if (g.t >= L.time) { g.score += Math.round(g.health / 2); return endLevel(); }
      hud();
    }
    function pop(text, x, y, color) { g.pops.push({ text: text, x: x, y: y, t: 0, color: color }); }

    /* ---------- input: touch, mouse, keyboard ---------- */
    function hitEnt(e) {
      var d = GUIDE[e.type];
      if (d.side === "friend") {
        g.mistakes++; g.health -= 8; g.score = Math.max(0, g.score - 10);
        pop("Ouch! That's a friend", e.x, e.y - 20, "#d63c30");
        tip('<span class="gj-tag friend">Friend</span><b>Oops, the ' + d.name.toLowerCase() + " is a garden friend!</b> " + d.fact, "oops"); g.tipLock = 4;
        if (e.type === "ladybug") { e.sp = 140; e.life = 0; }
        if (e.type === "bee") e.vx *= 2;
        if (e.type === "worm") e.life = 0.3;
        return;
      }
      if (e.type === "snail" && --e.hp > 0) { pop("Tap again!", e.x, e.y - 26, "#d63c30"); return; }
      e.dead = true; e.fly = 0; e.flick = true;
      var pts = e.type === "weed" ? 5 : e.type === "aphid" ? 10 : 15;
      g.score += pts; pop((e.type === "weed" ? "Pulled! +" : "+") + pts, e.x, e.y - 20, "#2f8f3e");
    }
    function pt(ev) { var r = cv.getBoundingClientRect(); return { x: (ev.clientX - r.left) * W / r.width, y: (ev.clientY - r.top) * H / r.height }; }
    cv.addEventListener("pointerdown", function (ev) {
      if (!g || g.mode !== "play") return;
      var p = pt(ev), cy = H * 0.13, cl = g.cloud;
      if (Math.abs(p.x - cl.x) < 70 && Math.abs(p.y - cy) < 42) { drag = { dx: p.x - cl.x }; cv.setPointerCapture(ev.pointerId); return; }
      var hit = null, bd = 1e9;
      g.ents.forEach(function (e) { if (e.dead || e.gone) return; var d = Math.hypot(e.x - p.x, e.y - p.y); if (d < e.r + 16 && d < bd) { bd = d; hit = e; } });
      if (hit) hitEnt(hit);
    });
    cv.addEventListener("pointermove", function (ev) { if (!drag) return; var p = pt(ev); g.cloud.x = Math.max(60, Math.min(W - 60, p.x - drag.dx)); });
    var up = function () { drag = null; };
    cv.addEventListener("pointerup", up); cv.addEventListener("pointercancel", up);
    cv.addEventListener("keydown", function (ev) {
      if (!g || g.mode !== "play") return;
      if (ev.key === "ArrowLeft" || ev.key === "ArrowRight") { keys[ev.key] = true; ev.preventDefault(); }
      if (ev.key === " " || ev.key === "Enter") {
        ev.preventDefault();
        var target = null, bd = 1e9, ph = g.gy - plantH() / 2;
        g.ents.forEach(function (e) { if (e.dead || e.gone || GUIDE[e.type].side !== "foe") return; var d = Math.hypot(e.x - g.px, e.y - ph); if (d < bd) { bd = d; target = e; } });
        if (target) hitEnt(target);
      }
      if (ev.key === "p" || ev.key === "P" || ev.key === "Escape") pause();
    });
    cv.addEventListener("keyup", function (ev) { keys[ev.key] = false; });
    $("pause").addEventListener("click", pause);

    function hud() {
      $("hp").textContent = Math.round(g.health);
      $("hpf").style.width = g.health + "%";
      $("hpf").style.background = g.health > 60 ? "var(--gj-green)" : g.health > 30 ? "var(--gj-sun)" : "var(--gj-foe)";
      $("wtf").style.width = g.water + "%";
      $("wt").textContent = g.water < WATER_LOW ? "Too dry" : g.water > WATER_HIGH ? "Too wet" : "Just right";
      $("score").textContent = g.score;
      $("lvl").textContent = "Level " + (g.level + 1) + " · " + Math.max(0, Math.ceil(LEVELS[g.level].time - g.t)) + "s";
    }

    /* ---------- drawing (all shapes drawn in code; swap for illustrator sprites later) ---------- */
    function circ(x, y, r, c) { ctx.fillStyle = c; ctx.beginPath(); ctx.arc(x, y, r, 0, Math.PI * 2); ctx.fill(); }
    function ell(x, y, rx, ry, c, a) { ctx.fillStyle = c; ctx.beginPath(); ctx.ellipse(x, y, rx, ry, a || 0, 0, Math.PI * 2); ctx.fill(); }
    function draw() {
      if (!g) return;
      var sky = ctx.createLinearGradient(0, 0, 0, g.gy); sky.addColorStop(0, "#bfe3f5"); sky.addColorStop(1, "#eaf7fc");
      ctx.fillStyle = sky; ctx.fillRect(0, 0, W, H);
      circ(W - 46, 46, 24, "#f6b81f");
      ctx.fillStyle = "#7b5131"; ctx.fillRect(0, g.gy, W, H - g.gy);
      for (var i = 0; i < 26; i++) circ((i * 53) % W, g.gy + 14 + (i * 29) % Math.max(1, H - g.gy - 18), 2.5, "#5c3b22");
      if (g.water > 30) { ctx.globalAlpha = (g.water - 30) / 140; ctx.fillStyle = "#1a0f06"; ctx.fillRect(g.px - 70, g.gy, 140, 22); ctx.globalAlpha = 1; }
      drawPlant();
      g.ents.forEach(drawEnt);
      drawCloud();
      g.pops.forEach(function (p) { ctx.globalAlpha = 1 - p.t / 1.2; ctx.fillStyle = p.color; ctx.font = "800 15px Nunito, Arial, sans-serif"; ctx.textAlign = "center"; ctx.fillText(p.text, p.x, p.y - p.t * 30); ctx.globalAlpha = 1; });
    }
    function drawCloud() {
      var cl = g.cloud, y = H * 0.13;
      if (cl.raining && g.mode === "play") {
        ctx.strokeStyle = "#1e8fe1"; ctx.lineWidth = 3; ctx.lineCap = "round";
        for (var i = 0; i < 9; i++) {
          var x = cl.x - 40 + i * 10, off = reduced ? i * 9 : ((performance.now() / 4 + i * 37) % 60);
          for (var yy = y + 26 + off; yy < g.gy - 4; yy += 60) { ctx.beginPath(); ctx.moveTo(x, yy); ctx.lineTo(x - 2, yy + 10); ctx.stroke(); }
        }
      }
      circ(cl.x - 34, y + 8, 22, "#fff"); circ(cl.x, y - 6, 30, "#fff"); circ(cl.x + 34, y + 8, 22, "#fff"); ell(cl.x, y + 14, 58, 16, "#fff");
      ctx.fillStyle = "#56798f"; ctx.font = "800 11px Nunito, Arial, sans-serif"; ctx.textAlign = "center"; if (!drag) ctx.fillText("drag me", cl.x, y + 18);
    }
    function drawPlant() {
      var h = plantH(), x = g.px, y0 = g.gy, sick = g.health < 40;
      var leaf = sick ? "#b4b33f" : "#3e9a49", sway = reduced ? 0 : Math.sin(performance.now() / 900) * 3;
      ctx.strokeStyle = sick ? "#8e9a35" : "#2a6f33"; ctx.lineWidth = 6 + g.level * 1.5; ctx.lineCap = "round";
      ctx.beginPath(); ctx.moveTo(x, y0); ctx.quadraticCurveTo(x - 8, y0 - h * 0.5, x + sway, y0 - h); ctx.stroke();
      var n = 2 + g.level * 2;
      for (var i = 0; i < n; i++) {
        var f = (i + 1) / (n + 1), lx = x + sway * f, ly = y0 - h * f, s = 0.7 + (1 - f) * 0.6 + g.level * 0.15, dir = i % 2 ? 1 : -1;
        ctx.save(); ctx.translate(lx, ly); ctx.rotate(dir * 0.5 - (dir < 0 ? Math.PI : 0)); ctx.scale(s, s);
        ctx.fillStyle = leaf; ctx.beginPath(); ctx.moveTo(0, 0); ctx.bezierCurveTo(10, -14, 32, -12, 38, 0); ctx.bezierCurveTo(32, 12, 10, 14, 0, 0); ctx.fill(); ctx.restore();
      }
      var tx = x + sway, ty = y0 - h;
      if (g.level === 2 || g.mode === "won") {
        var open = g.mode === "won" ? 1 : Math.min(1, g.t / LEVELS[2].time);
        for (var a = 0; a < 6; a++) { ctx.save(); ctx.translate(tx, ty); ctx.rotate(a * Math.PI / 3); ell(0, -10 - 8 * open, 6 + 5 * open, 10 + 8 * open, "#f6c444"); ctx.restore(); }
        circ(tx, ty, 8 + 4 * open, "#8a4f1f");
      } else ell(tx, ty - 4, 7, 10, "#3e9a49");
    }
    function drawEnt(e) {
      ctx.save();
      var x = e.x, y = e.y, T = e.t;
      if (e.dead) { ctx.globalAlpha = Math.max(0, 1 - e.fly / 0.6); if (e.flick) { y -= e.fly * 180; x += (x < g.px ? -1 : 1) * e.fly * 120; } }
      ctx.translate(x, y);
      if (e.type === "aphid") { var b = Math.sin(T * 12) * 1.5; ell(0, b, 9, 6.5, "#8cc84b"); circ(-8, b - 1, 4, "#6aa835"); ctx.strokeStyle = "#4f7d27"; ctx.lineWidth = 1.5; [-4, 0, 4].forEach(function (s) { ctx.beginPath(); ctx.moveTo(s, b + 4); ctx.lineTo(s - 2, b + 9); ctx.stroke(); }); }
      if (e.type === "ladybug") { ctx.rotate((e.ang || 0) + Math.PI / 2); circ(0, 0, 12, "#d93a2f"); circ(0, -11, 6, "#222"); ctx.strokeStyle = "#222"; ctx.lineWidth = 1.5; ctx.beginPath(); ctx.moveTo(0, -6); ctx.lineTo(0, 12); ctx.stroke(); [[-5, -1], [5, -1], [-5, 6], [5, 6]].forEach(function (p) { circ(p[0], p[1], 2.5, "#222"); }); }
      if (e.type === "caterpillar") { var dir = e.x < g.px ? 1 : -1; for (var i = 0; i < 5; i++) circ(-dir * i * 9, Math.sin(T * 8 - i) * 2.5, 7, i % 2 ? "#9bc53d" : "#b5d65a"); circ(dir * 8, -1, 7.5, "#7fae2e"); circ(dir * 10, -3, 1.8, "#222"); }
      if (e.type === "snail") { var sd = e.x < g.px ? 1 : -1; ell(sd * 4, 6, 20, 6, "#c9b28d"); circ(-sd * 2, -4, 12, "#9a6a3c"); ctx.strokeStyle = "#6e4523"; ctx.lineWidth = 2; ctx.beginPath(); ctx.arc(-sd * 2, -4, 6, 0, Math.PI * 1.6); ctx.stroke(); ctx.strokeStyle = "#c9b28d"; ctx.beginPath(); ctx.moveTo(sd * 18, 3); ctx.lineTo(sd * 22, -8); ctx.stroke(); circ(sd * 22, -9, 2, "#222"); if (e.hp > 1) { ctx.fillStyle = "#fff"; ctx.font = "800 10px Nunito, Arial, sans-serif"; ctx.textAlign = "center"; ctx.fillText("x2", -sd * 2, -1); } }
      if (e.type === "weed") { var s = 0.4 + e.grow * 0.8; ctx.scale(s, s); ctx.fillStyle = "#3f6f2a"; [[-0.5, 26], [0, 34], [0.5, 26], [-0.25, 30], [0.25, 30]].forEach(function (q) { ctx.save(); ctx.rotate(q[0]); ctx.beginPath(); ctx.moveTo(-4, 0); ctx.lineTo(0, -q[1]); ctx.lineTo(4, 0); ctx.fill(); ctx.restore(); }); }
      if (e.type === "bee") { var bd = e.vx > 0 ? 1 : -1; ell(-2, -10, 8, 5, "rgba(232,244,255,.9)", Math.sin(T * 40) * 0.4); ell(0, 0, 12, 8, "#f2c230"); ctx.fillStyle = "#222"; ctx.fillRect(-4, -8, 3, 16); ctx.fillRect(2, -8, 3, 16); circ(bd * 11, -1, 5, "#222"); }
      if (e.type === "worm") { var u = Math.min(1, e.t * 2, Math.max(0, e.life) * 2); ctx.strokeStyle = "#e38d8d"; ctx.lineWidth = 9; ctx.lineCap = "round"; ctx.beginPath(); ctx.moveTo(-14, 6); ctx.quadraticCurveTo(-4, -18 * u + Math.sin(T * 6) * 4, 10, -8 * u); ctx.stroke(); circ(10, -8 * u - 2, 1.8, "#222"); }
      if (e.label > 0 && !e.dead) {
        var d = GUIDE[e.type], txt = d.name + " · " + (d.side === "friend" ? "friend" : "pest");
        ctx.font = "800 12px Nunito, Arial, sans-serif"; var w = ctx.measureText(txt).width + 14;
        ctx.globalAlpha = Math.min(1, e.label); ctx.fillStyle = d.side === "friend" ? "#1e8fe1" : "#d63c30";
        ctx.beginPath(); if (ctx.roundRect) ctx.roundRect(-w / 2, -46, w, 22, 11); else ctx.rect(-w / 2, -46, w, 22); ctx.fill();
        ctx.fillStyle = "#fff"; ctx.textAlign = "center"; ctx.fillText(txt, 0, -31);
      }
      ctx.restore();
    }

    /* ---------- boot ---------- */
    g = fresh(); size(); hud(); book(); shelf();
    window.addEventListener("resize", size);
    document.addEventListener("visibilitychange", function () { if (document.hidden) pause(); });
    tip("<b>Hi, I'm Bella!</b> Your plant needs a protector. Are you ready?", null);
    cv.parentElement.classList.add("gr-stage--intro");
    overlay('<img class="gj-mascot" src="' + mascot + '" alt=""><p>Protect your plant from pests and help it grow.</p>' +
      (best ? "<p>Your best score: " + best + "</p>" : ""), "Start", begin);
  }

  function init() { document.querySelectorAll('[data-kids-app="garden-rescue"]').forEach(mount); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init); else init();
})();
